import { tv } from 'tailwind-variants';

/** SLI percentage text, colored by the monitor's live status so it
 *  always agrees with the status label next to it. Non-outage states
 *  keep the default text color. */
export const sliValueVariants = tv({
  base: 'font-mono text-sm font-semibold',
  variants: {
    status: {
      DOWN: 'text-red-400',
      DEGRADED: 'text-amber-400',
    },
  },
});
